import { FC, useState, useCallback } from 'react'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { deleteCarActionCreator } from 'actions/propertyActions'
import ConfirmModalComponent from 'components/features/pfm/ConfirmModal/ConfirmModal'

type CarDeleteHandlerProps = {
  carId: number
  onConfirm?: () => void
}

export const CarDeleteHandler: FC<CarDeleteHandlerProps> = (props) => {
  const { children, carId, onConfirm } = props

  const [isConfirmShown, setIsConfirmShown] = useState(false)
  const showConfirm = useCallback(() => setIsConfirmShown(true), [])
  const hideConfirm = useCallback(() => setIsConfirmShown(false), [])

  const dispatch = useStoreDispatch()
  const handleConfirm = useCallback(() => {
    hideConfirm()
    dispatch(deleteCarActionCreator(carId))
    onConfirm && onConfirm()
  }, [dispatch, carId, onConfirm, hideConfirm])

  return (
    <>
      <span onClick={ showConfirm }>
        { children }
      </span>
      { isConfirmShown && (
        <ConfirmModalComponent onCancel={ hideConfirm } onConfirm={ handleConfirm } confirmButtonText='Delete'>
          Deleting this car will permanently remove all of its historical data as well. Are you sure you want to delete this car?
        </ConfirmModalComponent>
      )}
    </>
  )
}
